import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlatformTutorialsService from "services/PlatformTutorialsService";

const initialState = {
  platformTutorials: [],
  loading: false,
  error: null,
};

export const getPlatformTutorials = createAsyncThunk(
  "platformTutorials/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PlatformTutorialsService.getAll();
      return response.data.data.platformTutorials;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error");
    }
  }
);

export const createPlatformTutorial = createAsyncThunk(
  "platformTutorials/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await PlatformTutorialsService.create(data);
      return response.data.data.platformTutorial;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error");
    }
  }
);

export const updatePlatformTutorial = createAsyncThunk(
  "platformTutorials/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PlatformTutorialsService.update(id, data);
      return response.data.data.platformTutorial;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error");
    }
  }
);

export const deletePlatformTutorial = createAsyncThunk(
  "platformTutorials/delete",
  async (id, { rejectWithValue }) => {
    try {
      await PlatformTutorialsService.delete(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error");
    }
  }
);

const platformTutorialsSlice = createSlice({
  name: "platformTutorials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlatformTutorials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlatformTutorials.fulfilled, (state, { payload }) => {
        state.platformTutorials = payload;
        state.loading = false;
      })
      .addCase(getPlatformTutorials.rejected, (state, { payload }) => {
        state.error = payload;
        state.loading = false;
      })
      .addCase(createPlatformTutorial.fulfilled, (state, { payload }) => {
        state.platformTutorials.push(payload);
      })
      .addCase(updatePlatformTutorial.fulfilled, (state, { payload }) => {
        state.platformTutorials = state.platformTutorials.map((t) =>
          t._id === payload._id ? payload : t
        );
      })
      .addCase(deletePlatformTutorial.fulfilled, (state, { payload }) => {
        state.platformTutorials = state.platformTutorials.filter(
          (t) => t._id !== payload
        );
      });
  },
});

export default platformTutorialsSlice.reducer;
